require('./bootstrap');

var window_height = $(window).height();
var screen_size = $(window).width();
$('#subheader, #subheader .rslides li ').css('height', window_height);

/*-------------------------------------------------*/
/* =  scroll to top
/*-------------------------------------------------*/
var to_top_icon = $('#top');
$(to_top_icon).hide();
$(window).scroll(function() {
    if ($(this).scrollTop() > 75) {
        to_top_icon.fadeIn();
    } else {
        to_top_icon.fadeOut();
    }
});


/*-------------------------------------------------*/
/* =  scroll on link
/*-------------------------------------------------*/
if ($(window).width() < 768) {
    var top_ofset = $('header').height() + 40;
} else {
    var top_ofset = $('header').height() + 91;
}

var top_ofset = $('header').height() + 40;

$('header nav ul a,.findout-more,.logo, .scroll-down, #top').smoothScroll({
    offset: -top_ofset,
    // one of 'top' or 'left'
    direction: 'top',
    // only use if you want to override default behavior
    scrollTarget: null,
    // fn(opts) function to be called before scrolling occurs.
    // `this` is the element(s) being scrolled
    beforeScroll: function() {},
    // fn(opts) function to be called after scrolling occurs.
    // `this` is the triggering element
    afterScroll: function() {},
    easing: 'easeInOutExpo',
    speed: 1000,
    // coefficient for "auto" speed
    autoCoefficent: 2,
    // $.fn.smoothScroll only: whether to prevent the default click action
    preventDefault: true
});


[].slice.call(document.querySelectorAll('.rslides_tabs')).forEach(function(nav) {
    new DotNav(nav, {
        callback: function(idx) {
            //console.log( idx )
        }
    });
});

/*-------------------------------------------------*/
/* =  scroll over
/*-------------------------------------------------*/
var navigation = $('header');
$(window).scroll(function() {
    if ($(window).scrollTop() > (window_height - 156)) {
        navigation.addClass('change');
        navigation.delay(1000).queue(function() {
            $(this).addClass('animate')
        });
    } else {
        navigation.removeClass('change animate');
    }
});
